module.exports = __webpack_public_path__ + "img/air_temp.2b1d2bd4.svg";